/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_UnstartedInputs */

const en_status_unstarted = /** @type {(inputs: Status_UnstartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unstarted`)
};

const de_status_unstarted = /** @type {(inputs: Status_UnstartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht begonnen`)
};

/**
* | output |
* | --- |
* | "Unstarted" |
*
* @param {Status_UnstartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_unstarted = /** @type {((inputs?: Status_UnstartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_UnstartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_status_unstarted(inputs)
	return en_status_unstarted(inputs)
});